const lyndusPassRoutes = [
    {
        path: "/lynduspass",
        name: "lynduspass",
        component: () => import("@/views/lynduspass/LyndusPass")
    }
]
export default lyndusPassRoutes